// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-entity-button{padding-left:50px}", "",{"version":3,"sources":["webpack://src/components/Factory/Molecules/Common/Navigations/AddEntity/M_AddEntity.scss"],"names":[],"mappings":"AAAA,mBACI,iBAAA","sourcesContent":[".add-entity-button{\r\n    padding-left: 50px;\r\n}\r\n   \r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
